import { DutyRosterPeriodStatus } from "@/routes/app/-components/DutyRosterPeriodStatus"
import classes from "./cells.module.css"
import { Permission } from "@/@client/Theasoft_DataTypes_Enums"
import { SetWorkAreaWeekStatusModal } from "../../../-components/SetWorkAreaWeekStatusModal"
import { useDisclosure } from "@mantine/hooks"
import { MatrixOrientation } from "../matrix-css-grid"
import { CSSProperties } from "react"
import { Text } from "@mantine/core"

export function WorkAreaStatusCell({
  statusId,
  workAreaId,
  date,
  permission,
  span,
  orientation,
}: {
  statusId: number | undefined
  workAreaId: number
  date: string
  permission: Permission
  span: number
  orientation: MatrixOrientation
}) {
  const [opened, { open, close }] = useDisclosure()
  const orientationStyles: CSSProperties =
    orientation === "transpose"
      ? {
          writingMode: "vertical-lr",
          transform: "rotate(180deg)",
          maxHeight: "58px",
          gridRow: `span ${span}`,
        }
      : {
          gridColumn: `span ${span}`,
        }
  return (
    <div
      onClick={() => permission === "ReadAndWrite" && open()}
      className={classes["workarea-target-roles-cell"]}
      style={{
        padding: "4px",
        display: "flex",
        alignItems: "center",
        cursor: permission === "ReadAndWrite" ? "pointer" : "default",
        ...orientationStyles,
      }}
    >
      {statusId ? (
        <Text
          truncate
          ta="center"
          tt="uppercase"
          fs={"italic"}
          fw={"bold"}
          size="xs"
        >
          <DutyRosterPeriodStatus id={statusId} />
        </Text>
      ) : null}
      <SetWorkAreaWeekStatusModal
        opened={opened}
        onClose={close}
        workAreaId={workAreaId}
        date={date}
        fromStatus={statusId ?? null}
      />
    </div>
  )
}
